import { render } from "./ReferencedObjectView.vue?vue&type=template&id=b705534c"
import script from "./ReferencedObjectView.vue?vue&type=script&lang=js"
export * from "./ReferencedObjectView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__